import { SxProps } from '@mui/material';

export const styles: Record<string, SxProps> = {
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '24px',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '12px',
  },
  button: {
    borderRadius: '14px',
    padding: '10px 16px',
  },
};
